import { render, staticRenderFns } from "./textItem.vue?vue&type=template&id=c73f5c6c"
import script from "./textItem.vue?vue&type=script&lang=js"
export * from "./textItem.vue?vue&type=script&lang=js"
import style0 from "./textItem.vue?vue&type=style&index=0&id=c73f5c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports